// React-Screen CTimeRecord ("Zeiterfassung") - Strangler Phase 5 (entschalt).
// Runbook: tools/REACT-STRANGLER.md.
//
// ENTSCHALT am 23.8.2026. Dafuer ist das DATENGITTER nach React gekommen
// (DataGrid in react/widgets.jsx). Es ist das einzige Widget, dessen Kinder
// erst zur Laufzeit entstehen: makeTimetable() ruft clear() und fuellt dann
// in einer Schleife addRowWithColumns(). Genau diese Schnittstelle behaelt
// das Handle, die Methoden unten bleiben also woertlich die alten - nur
// schreiben sie jetzt in ein Datenmodell, aus dem React rendert.
//
// ACHTUNG beim Aendern: die ZEILEN des Gitters stehen in KEINER Baseline
// (der Galerie-Eintrag nimmt das Gitter heraus, weil seine Zeilenzahl mit
// jedem Testlauf waechst). Alles andere an diesem Screen ist seit dem
// 23.8.2026 abgedeckt - vorher war die Maske '.CTimeRecord table' und nahm
// auch die Klickziffern und die Textzeilen mit heraus.
import { defineReactScreen } from '../bridge.js';
import { CPushButton } from '../../components/pushbutton.js';
import {
  Caption, TextLabel, PagedPushPanel, MultiClickNumber, DataGrid,
  verdrahtePagedPushPanel, verdrahteMultiClickNumber, gitterVorbereiten,
} from '../widgets.jsx';

// Die vier Ueberschriften sehen gleich aus.
const TITELSCHRIFT = { fontSize: '1.8vh', fontWeight: 'bold' };
// Die drei Bildknoepfe der Titelzeile ebenso.
const BILDKNOPF = (bild, rechts) => ({
  position: 'absolute', right: rechts, top: '0px', width: '4.5%', height: '90%',
  backgroundImage: `url(${bild})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center',
});

function CTimeRecordScreen({ bridge }) {
  const knopf = (pfad, style, handler, params, text, klasse) => (
    <div {...bridge.widget(pfad, 'CPushButton', {
           events: { onMousedown: handler, onMouseout: true, onMouseup: true },
           attributes: params,
           proto: CPushButton.prototype,
         })}
         className={'CPushButton' + (klasse ? ' ' + klasse : '')} style={style}>
      <p {...bridge.el(`${pfad}:0`, 'CCaption')} className={'CCaption ' + (text || 'undefined')}
         dangerouslySetInnerHTML={{ __html: text || '' }} />
    </div>
  );

  return (
    <>
      {/* titleContainer */}
      <div {...bridge.el('0', 'CFrame')} className="CFrame"
           style={{ position: 'absolute', left: '0px', top: '0px', height: '6.8%', width: '100%' }}>
        <Caption bridge={bridge} pfad="0:0" text={'Zeiterfassung f&uuml;r ' + (bridge.userName || '')}
                 style={{ position: 'absolute', left: '5px', top: '7px',
                          fontSize: '2.8vh', fontWeight: 'bold' }} />
        {knopf('0:1', BILDKNOPF('lib/img/OK.png', '5.7%'), bridge.logout,
               { onMousedown_parameter_0: bridge.id })}
        {knopf('0:2', BILDKNOPF('lib/img/08_X.png', '0px'), bridge.close,
               { onMousedown_parameter_0: bridge.id })}
      </div>

      {/* Gehen-Gruende */}
      <TextLabel bridge={bridge} pfad="1" text="Gehen:" textStyle={TITELSCHRIFT}
                 style={{ width: '25vw', height: '4vh', top: '7vh', left: '3vw' }} />
      <PagedPushPanel bridge={bridge} pfad="2" zeilen={7} spalten={1}
                      style={{ width: '25vw', height: '49vh', left: '3vw', top: '10.5vh' }}
                      knopfStyle={{ width: '98%' }}
                      knoepfe={bridge.grundKnoepfe || []} />

      {/* Schichten */}
      <TextLabel bridge={bridge} pfad="3" text="Schicht:" textStyle={TITELSCHRIFT}
                 style={{ width: '25vw', height: '4vh', top: '7vh', left: '30vw' }} />
      <PagedPushPanel bridge={bridge} pfad="4" zeilen={11} spalten={2}
                      style={{ width: '25vw', height: '77vh', left: '30vw', top: '10.5vh' }}
                      knopfStyle={{ width: '49%' }}
                      knoepfe={bridge.schichtKnoepfe || []} />

      {/* Angeordnete Ueberstunden */}
      <TextLabel bridge={bridge} pfad="5" text="Angeordnete UStd.:" textStyle={TITELSCHRIFT}
                 style={{ width: '25vw', height: '4vh', top: '61vh', left: '3vw' }} />
      <div {...bridge.el('6', 'CFrame')} className="CFrame"
           style={{ position: 'absolute', width: '25vw', height: '17vh', left: '3vw', top: '65vh' }}>
        {/* Die XML gibt links "29px" an - die Ziffernrechnung erwartet aber
            "vw" und macht daraus NaN. Alle Ziffern landen deshalb ohne
            left-Angabe an ihrer statischen Position. Das ist seit jeher so
            und bleibt so. */}
        <MultiClickNumber bridge={bridge} pfad="6:0" links="29px" oben="12px"
                          vorkomma={1} nachkomma={2}
                          style={{ position: 'absolute', width: '5vw', height: '7vh' }} />
        {knopf('6:1', { position: 'absolute', left: '0px', top: '20vh', width: '30%', height: '4vh' },
               bridge.setExtraHours, { onMousedown_parameter_0: bridge.id }, 'Eintragen', 'eintragen')}
      </div>

      {/* Heutige Buchungen */}
      <TextLabel bridge={bridge} pfad="7" text="Heute:" textStyle={TITELSCHRIFT}
                 style={{ width: '41vw', height: '4vh', top: '7vh', right: '5px' }} />
      <div {...bridge.el('8', 'CFrame')} className="CFrame"
           style={{ position: 'absolute', overflow: 'hidden', borderStyle: 'solid',
                    borderWidth: '2px', height: '58vh', width: '35vw', top: '11vh', right: '6vw' }}>
        <DataGrid bridge={bridge} pfad="8:0" />
      </div>

      {/* Blaetterpfeile fuer die Liste */}
      <div {...bridge.el('9', 'CFrame')} className="CFrame"
           style={{ position: 'absolute', overflow: 'hidden', borderStyle: 'solid',
                    borderWidth: '0px', height: '58vh', width: '5vw', top: '11vh', right: '5px' }}>
        {knopf('9:0', { position: 'absolute', left: '0px', top: '0px', width: '95%', height: '10%',
                        backgroundImage: 'url(lib/img/bonedit/01scrollup.png)',
                        backgroundRepeat: 'no-repeat', backgroundPosition: 'center' },
               bridge.scroll, { onMousedown_parameter_0: bridge.id, onMousedown_parameter_1: -30 })}
        {knopf('9:1', { position: 'absolute', left: '0px', bottom: '0px', width: '95%', height: '10%',
                        backgroundImage: 'url(lib/img/bonedit/07scrolldown.png)',
                        backgroundRepeat: 'no-repeat', backgroundPosition: 'center' },
               bridge.scroll, { onMousedown_parameter_0: bridge.id, onMousedown_parameter_1: 30 })}
      </div>
    </>
  );
}

const legacy = {};


legacy.prepare = function() {

    var defret = jQuery.Deferred();
    var TimeRecordClass = this;

    this.Main = POS.sessions.getSessionComponent();

    // Das Datengitter muss es VOR dem ersten Rendern geben: makeTimetable()
    // fuellt es noch hier in prepare, damit draw() erst mit fertiger Liste
    // aufloest - so war es im Legacy auch. Die XML-Voreinstellungen fuer
    // Zeilen und Spalten stehen jetzt hier statt in LYT_timeRecord.xml.
    gitterVorbereiten(this, '8:0', {
        canSelect: true,
        row: {
            styles: { height: "4vh", borderBottomStyle: "solid", borderBottomWidth: "1px" },
        },
        column: {
            styles: {
                textAlign: "left", verticalAlign: "middle",
                borderRightStyle: "solid", borderRightWidth: "1px",
            },
        },
    });
    // Die Namen aus der XML - makeTimetable() greift ueber
    // components.timetableContainer.components.list zu. Nach dem Mount
    // werden sie in mountLegacy erneut gesetzt (dann auf die echten Handles).
    this.nameComponent('8', 'timetableContainer');
    this.nameComponent('8:0', 'list');

    $.when(this.makeReasonButtons()).then(function(btns) {
        TimeRecordClass.grundKnoepfe = btns;
        $.when(TimeRecordClass.makeShiftButtons()).then(function(btns2) {
            TimeRecordClass.schichtKnoepfe = btns2;
            $.when(TimeRecordClass.makeTimetable()).done(function() {
                TimeRecordClass.prepared = true;
                defret.resolve();
            });
        });
    });
    return defret.promise();
}

legacy.scroll = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    me.components.timetableContainer.scroll(parameters[1]);
}

legacy.getZeroTimestamp = function() {
    return window.TimeRecordDomain.todayZeroTimestamp();
}

legacy.makeTimetable = function() {
    var bonGrid = this.components.timetableContainer.components.list;
    bonGrid.clear();
    var defret = jQuery.Deferred();
    var newEntryRow = this.makeNewEntry();
    if (newEntryRow) {
        var row = bonGrid.addRowWithColumns(newEntryRow);
        row.selectable = false;
    }

    var minTimestamp = this.getZeroTimestamp();

    /*privMan.enablePrivilege (privList);*/

    window.TimeRecordDomain.getLoginId(this.userId).then(function(loginId) {
        window.TimeRecordDomain.getEntriesSince(loginId, minTimestamp).then(function(rows) {
            if (rows) {
                for (var j = 0; j < rows.length; j++) {
                    var columns = new Array();

                    for (var i = 0; i < 2; i++)
                        var n = columns.push(new CColumn(0, 0));

                    columns[0].properties.styles.width = "30%";

                    var d = new Date(rows[j].TS * 1000);

                    var textCol1 = "&nbsp;Datum: " + d.getDate() + "." + (d.getMonth() + 1) +
                        "." + (d.getYear() + 1900) + "<br>&nbsp;Uhrzeit: " + d.toLocaleTimeString();

                    var eventDB = rows[j].Event;
                    var reasonDB = rows[j].Reason;
                    var shiftDB = rows[j].Shift;
                    var extraHoursDB = rows[j].ExtraHours;

                    switch (eventDB) {
                        case "KOM":
                            var eventText = "&nbsp;Kommzeit";
                            columns[0].properties.styles.backgroundColor = "#E2E2E2";
                            columns[1].properties.styles.backgroundColor = "#E2E2E2";
                            break;
                        case "GEH":
                            eventText = "&nbsp;Gehzeit";
                            break;
                    }

                    var textCol2 = eventText;
                    textCol2 += (reasonDB ? ("<br>&nbsp;Grund: " + reasonDB) : "");
                    textCol2 += (shiftDB ? ("<br>&nbsp;Schicht: " + shiftDB) : "");
                    textCol2 += (extraHoursDB ? ("<br>&nbsp;&Uuml;Std.: " + extraHoursDB) : "");

                    columns[0].properties.value = String(textCol1);
                    columns[1].properties.value = textCol2;

                    var row = bonGrid.addRowWithColumns(columns);
                    row.selectable = false;
                    //r.moveNext();
                }
            }
            defret.resolve();
        }, function(error) { //reject
            defret.resolve();
        });
    });
    return defret.promise();
}

legacy.makeNewEntry = function() {
    if (!this.reason && !this.shift && !this.extraHours)
        return null;

    var columns = new Array();

    for (var i = 0; i < 2; i++)
        var n = columns.push(new CColumn(0, 0));

    columns[0].properties.styles.width = "10.94%";

    columns[0].properties.styles.backgroundColor = "#BBBBFF";
    columns[1].properties.styles.backgroundColor = "#BBBBFF";

    var textCol1 = "&nbsp;Neuer Eintrag:";
    var textCol2 = "&nbsp;Gehzeit";
    textCol2 += (this.reason ? ("<br>&nbsp;Grund: " + this.reason) : "");
    textCol2 += (this.shift ? ("<br>&nbsp;Schicht: " + this.shift) : "");
    textCol2 += (this.extraHours ? ("<br>&nbsp;&Uuml;Std.: " + this.extraHours) : "");

    columns[0].properties.value = textCol1;
    columns[1].properties.value = textCol2;

    return columns;
}

legacy.logoutAuto = function() {
    /*privMan.enablePrivilege (privList);*/

    var d = new Date();

    window.TimeRecordDomain.getLoginId(this.userId).then(function(loginId) {
        window.TimeRecordDomain.insertEvent(loginId, (d / 1000).toFixed(0), 'GEH', 'Kassaabschluss', null, null);
    });
}

legacy.logout = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    if (!me.reason) {
        var text = POS.lang.getText("MESSAGES", "NO_REASON");
        POS.message.show(text, "warning", "");

        return;
    }

    if (!me.shift) {
        var text = POS.lang.getText("MESSAGES", "NO_SHIFT");
        POS.message.show(text, "warning", "");

        return;
    }

    if (!me.extraHours) {
        me.extraHours = 0;
    }

    /*privMan.enablePrivilege (privList);*/

    var extraHoursDB = parseFloat(remEuropeanComma(me.extraHours));

    var d = new Date();

    window.TimeRecordDomain.getLoginId(me.userId).then(function(loginId) {
        window.TimeRecordDomain.insertEvent(loginId, (d / 1000).toFixed(0), 'GEH', me.reason, me.shift, extraHoursDB);

        POS.sessions.closeSessionFromId(me.userId, false);

        POS.sessions.openSessions[0].components.container.components.user.field.input.setFocus();
    });
}

// Signatur (jQuery-Deferred) fuer externe Aufrufer erhalten - Logik liegt
// jetzt in der Domaene (native Promise, am Rand umgefuellt).
legacy.getLoginId = function(userId) {
    var dfd = jQuery.Deferred();
    window.TimeRecordDomain.getLoginId(userId).then(function(loginId) {
        dfd.resolve(loginId);
    });
    return dfd.promise();
}

legacy.setComeTime = function(userId) {
    /*privMan.enablePrivilege (privList);*/

    window.TimeRecordDomain.getLoginId(userId).then(function(loginId) {
        window.TimeRecordDomain.getLastComeTime(loginId).then(function(lastTimestampDB) {
            var today = new Date();

            if (lastTimestampDB !== null) {
                var lastDate = new Date(lastTimestampDB * 1000);
                var lastYear = lastDate.getYear();
                var lastMonth = lastDate.getMonth();
                var lastDay = lastDate.getDate();

                var thisYear = today.getYear();
                var thisMonth = today.getMonth();
                var thisDay = today.getDate();

                if (lastYear == thisYear && lastMonth == thisMonth && lastDay == thisDay) {
                    return;
                }
            }

            window.TimeRecordDomain.insertEvent(loginId, (today / 1000).toFixed(0), 'KOM', null, null, null);
        });
    });
}

legacy.setReason = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    var i = parameters[1];

    // Die Knoepfe sind seit 23.8.2026 reine Daten (makeReasonButtons) - das
    // alte goSelect.buttons[i].properties.caption gibt es nicht mehr, der
    // Klick warf (Code-Suche 30.9.2026).
    me.reason = me.grundKnoepfe[i].text;

    var defret = jQuery.Deferred();
    $.when(me.makeTimetable()).done(function() {
        me.components.timetableContainer.reDraw();
        defret.resolve();
    });
    return defret.promise();
}

legacy.setShift = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    var i = parameters[1];

    me.shift = me.schichtKnoepfe[i].text; // wie setReason: Knoepfe sind Daten

    $.when(me.makeTimetable()).done(function() {
        me.components.timetableContainer.reDraw();
    });
}

legacy.setExtraHours = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    me.extraHours = me.components.overTimeContainer.components.overTimeDisplay.getValue();

    $.when(me.makeTimetable()).done(function() {
        me.components.timetableContainer.reDraw();
    });
}

legacy.makeReasonButtons = function() {
    /*privMan.enablePrivilege (privList);*/
    var TimeRecordClass = this;
    var dfd = jQuery.Deferred();

    window.TimeRecordDomain.getReasons().then(function(rows) {
        var btns = new Array();

        for (var i = 0; i < rows.length; i++) {
            // Seit 23.8.2026 reine DATEN - das Raster rendert PagedPushPanel.
            btns[i] = {
                text: rows[i].Reason,
                handler: TimeRecordClass.setReason,
                param0: TimeRecordClass.id,
                param1: i,
            };
        }

        //r.free();
        //return btns;
        dfd.resolve(btns);
    });
    return dfd.promise();
}

legacy.makeShiftButtons = function() {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var TimeRecordClass = this;
    window.TimeRecordDomain.getShifts().then(function(rows) {
        var btns = new Array();

        for (var i = 0; i < rows.length; i++) {
            var shift = rows[i].Shift;
            // Eine Schicht ohne Text bleibt unsichtbar - dann haengt auch
            // kein Handler daran (woertlich wie im Legacy).
            if (!shift)
                btns[i] = { text: '', style: { visibility: "hidden" } };
            else
                btns[i] = {
                    text: shift,
                    handler: TimeRecordClass.setShift,
                    param0: TimeRecordClass.id,
                    param1: i,
                };
        }

        /*r.free();
        return btns;*/
        dfd.resolve(btns);
    });
    return dfd.promise();
}

legacy.checkIfPauseActive = function() {
    /*privMan.enablePrivilege (privList);*/
    var TimeRecordClass = this;
    window.TimeRecordDomain.getLoginId(this.userId).then(function(loginId) {
        window.TimeRecordDomain.getLastEntry(loginId).then(function(last) {
            if (last && last.Event == "GEH" && last.Reason == "Pause") {

                var text = POS.lang.getText("MESSAGES", "DEACTIVATE_PAUSE");
                POS.message.show(text, "warning", "OKCANCEL", TimeRecordClass, TimeRecordClass.backPause);
                return;
            }
        });
    });
}

legacy.goPause = function() {

    /*privMan.enablePrivilege (privList);*/
    var TimeRecordClass = this;
    window.TimeRecordDomain.getLoginId(this.userId).then(function(loginId) {
        var today = new Date();

        window.TimeRecordDomain.insertEvent(loginId, (today / 1000).toFixed(0), 'GEH', 'Pause', null, null).then(function() {


            var text = POS.lang.getText("MESSAGES", "DEACTIVATE_PAUSE");
            POS.message.show(text, "warning", "OKCANCEL", TimeRecordClass, TimeRecordClass.backPause);
            return;
        });
    });
}

legacy.cancelPause = function(TRId) {
    /*privMan.enablePrivilege (privList);*/

    window.TimeRecordDomain.deleteEntry(TRId);

    this.userId = null;
}

legacy.backPause = function(me, result) {

    /*privMan.enablePrivilege (privList);*/

    window.TimeRecordDomain.getLoginId(me.userId).then(function(loginId) {
        window.TimeRecordDomain.getLastEntry(loginId).then(function(last) {
            if (last) {
                var TRId = last.TR_ID;

                if (result == "CANCEL") {
                    me.cancelPause(TRId);
                    return;
                }

                var today = new Date();
                var nowTS = (today / 1000).toFixed(0);

                if (nowTS - parseFloat(last.TS) < 60) {
                    me.cancelPause(TRId);
                    return;
                } else {
                    window.TimeRecordDomain.insertEvent(loginId, nowTS, 'KOM', null, null, null);
                }

                me.userId = null;
            }
        });

    });
}

legacy.close = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    log.add(4, "Info", "Time record off", "");
    me.removeMe();
}



// Legacy-Konstruktor zum Uebertragen (addclass/htmlType/rootStyles/Felder):
// function CTimeRecord(id) {
//     this.construct(id,"CTimeRecord");
// 
//     this.collector = true;
//     this.htmlType = "div";
// 
//     this.properties = {
//         styles: {
//             backgroundColor: "#DFDFDF",
//             position: "absolute",
//             width: "100%",
//             height: "100%",
//             left: "0px",
//             top: "0px"
//         }
//     }
// 
//     this.userId = null;
//     this.userName = null;
//     this.reason = null;
//     this.shift = null;
//     this.extraHours = null;
//     this.Main = null;
// }
export const CTimeRecord = defineReactScreen({
  className: 'CTimeRecord',
  addclass: 'CTimeRecord',
  htmlType: 'div',
  Screen: CTimeRecordScreen,
  rootStyles: {
    backgroundColor: '#DFDFDF',
    position: 'absolute',
    width: '100%',
    height: '100%',
    left: '0px',
    top: '0px',
  },
  // userId und userName setzt CMainPOS.doTimeRecord zwischen Konstruktion
  // und draw() - deshalb fields() und nicht prepare().
  fields: () => ({
    collector: true,
    userId: null,
    userName: null,
    reason: null,
    shift: null,
    extraHours: null,
  }),
  // Das Legacy-prepare laeuft VOR create() - es holt die Knopf-Daten und
  // die heutigen Buchungen aus der DB, beides braucht React schon beim
  // ersten Rendern. Rueckgabe ist ein Deferred, die Bridge wartet.
  prepare(bridge) {
    return legacy.prepare.call(bridge);
  },
  // Nach dem Mount nur noch VERDRAHTUNG: die XML-Namen zeigen jetzt auf die
  // echten Handles (in prepare zeigten sie auf Platzhalter), und die
  // Ziffern sowie die beiden Knopf-Raster bekommen ihre Legacy-Felder.
  mountLegacy(bridge) {
    bridge.nameComponent('0', 'titleContainer');
    bridge.nameComponent('2', 'goSelect');
    bridge.nameComponent('4', 'shiftSelect');
    bridge.nameComponent('6', 'overTimeContainer');
    bridge.nameComponent('6:0', 'overTimeDisplay');
    bridge.nameComponent('8', 'timetableContainer');
    bridge.nameComponent('8:0', 'list');
    bridge.nameComponent('9', 'scroll');

    verdrahtePagedPushPanel(bridge, '2');
    verdrahtePagedPushPanel(bridge, '4');
    verdrahteMultiClickNumber(bridge, '6:0', 1, 2);

    // setReason/setShift/setExtraHours rufen nach makeTimetable()
    // timetableContainer.reDraw() - im Legacy baute das den Rahmen samt Liste
    // neu. Hier heisst das: die Liste neu rendern (ihr gitter.reDraw).
    // Vorher warf es "this.builder.addElement is not a function" (Code-Suche
    // 30.9.2026) - die Zeiterfassung startete die Kasse neu.
    bridge.handleAt('8').reDraw = function () {
      return bridge.handleAt('8:0').reDraw();
    };
  },
  legacyMethods: legacy,
});
